import {
    DELETE_USER_WEIGHT_GOAL,
    UPDATE_USER_GOAL,
    UPDATE_USER_GOAL_START,
    UPDATE_USER_GOAL_SUCCESS,
    ADD_USER_WEIGHT,
    SELECT_DATA_FOR_CHART,
    SET_CURRENT_PAGE_DATE,
    CLEAN_UP_DATA,
    ADD_USER_WEIGHT_START,
    ADD_USER_WEIGHT_SUCCESS,
    ADD_USER_WEIGHT_FAIL,
    TOGGLE_WEIGHT_OVERLAY,
    FETCH_FIRST_WEIGHT,
    FETCH_FIRST_WEIGHT_SUCCESS
} from 'actions/weightActions';
import DateFormatter from 'utils/date/DateFormatter';
import { AVAILABLE_WEIGHT_METRICS } from 'Weight/WeightUtils';

const INITIAL_STATE = {
    firstWeight: undefined,
    weightPageState: {
        updatingUserGoal: false,
        currentPageDate: null,
        addUserWeightFetching: null,
        overlayEnabled: false,
        selectedDataTypes: [AVAILABLE_WEIGHT_METRICS.weight]
    }
};

// ======= Fetching Handlers =======

const setCurrentPageDate = (state, action) => {
    let todayDate = DateFormatter.formatISODate(new Date());
    let verifiedCurrentDatePage = action.currentPageDate > todayDate ? todayDate : action.currentPageDate;

    return {
        ...state,
        weightPageState: {
            ...state.weightPageState,
            currentPageDate: verifiedCurrentDatePage
        }
    };
};

const selectDataTypeForChartState = (state, action) => {
    let dataTypes = state.weightPageState.selectedDataTypes;
    let selectedDataType = action.dataType;
    if (state.weightPageState.overlayEnabled) {
        if (dataTypes.indexOf(selectedDataType) > -1) {
            if (dataTypes.length > 1) {
                dataTypes = dataTypes.filter((dataType) => dataType !== selectedDataType);
            }
        } else {
            if (dataTypes.length > 1) {
                dataTypes.pop();
            }
            dataTypes.push(selectedDataType);
        }
    } else {
        dataTypes = [selectedDataType];
    }
    return {
        ...state,
        weightPageState: {
            ...state.weightPageState,
            selectedDataTypes: [...dataTypes]
        }
    };
};

const userGoalUpdateStart = (state) => {
    return {
        ...state,
        weightPageState: {
            ...state.weightPageState,
            updatingUserGoal: true
        }
    };
};

const userGoalUpdateSuccess = (state) => {
    return {
        ...state,
        weightPageState: {
            ...state.weightPageState,
            updatingUserGoal: false
        }
    };
};

const cleanUpData = (state) => {
    const processedState = INITIAL_STATE;
    processedState.weightPageState.selectedDataTypes = state.weightPageState.selectedDataTypes;
    processedState.weightPageState.overlayEnabled = state.weightPageState.overlayEnabled;
    return {
        ...state,
        weightPageState: processedState.weightPageState
    };
};

const addUserWeightStart = (state) => {
    return {
        ...state,
        weightPageState: {
            ...state.weightPageState,
            addUserWeightFetching: true
        }
    };
};

const addUserWeightFinish = () => (state, action) => {
    if (action.reloadPage) {
        window.location.reload();
    }
    return {
        ...state,
        weightPageState: {
            ...state.weightPageState,
            addUserWeightFetching: false
        }
    };
};

const toggleOverlayHandler = (state) => {
    const dataTypes = state.weightPageState.overlayEnabled
        ? [state.weightPageState.selectedDataTypes[0]]
        : state.weightPageState.selectedDataTypes;
    return {
        ...state,
        weightPageState: {
            ...state.weightPageState,
            overlayEnabled: !state.weightPageState.overlayEnabled,
            selectedDataTypes: dataTypes
        }
    };
};

const fetchFirstWeightSuccess = (state, action) => {
    const firstWeight = (action.data && action.data.date) || null;

    return {
        ...state,
        firstWeight
    };
};

// ======= Handler Assignments =======
const handlers = {
    [SELECT_DATA_FOR_CHART]: selectDataTypeForChartState,
    [UPDATE_USER_GOAL_START]: userGoalUpdateStart,
    [UPDATE_USER_GOAL_SUCCESS]: userGoalUpdateSuccess,
    [SET_CURRENT_PAGE_DATE]: setCurrentPageDate,
    [CLEAN_UP_DATA]: cleanUpData,
    [TOGGLE_WEIGHT_OVERLAY]: toggleOverlayHandler,
    [ADD_USER_WEIGHT_START]: addUserWeightStart,
    [ADD_USER_WEIGHT_SUCCESS]: addUserWeightFinish(true),
    [ADD_USER_WEIGHT_FAIL]: addUserWeightFinish(false),
    [FETCH_FIRST_WEIGHT_SUCCESS]: fetchFirstWeightSuccess
};

// ======= Default Action =======
export default function weightPage(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}

// ======= Actions =======
export function setTheCurrentPageDate(currentPageDate) {
    return {
        type: SET_CURRENT_PAGE_DATE,
        currentPageDate
    };
}

export function cleaUpData() {
    return {
        type: CLEAN_UP_DATA
    };
}

export function toggleOverlay() {
    return {
        type: TOGGLE_WEIGHT_OVERLAY
    };
}

export function updateUserWeightGoal(payload, displayName) {
    return {
        type: UPDATE_USER_GOAL,
        payload: payload,
        displayName: displayName
    };
}

export function deleteUserGoal(goalId) {
    return {
        type: DELETE_USER_WEIGHT_GOAL,
        goalId: goalId
    };
}

export function selectDataTypeForChart(dataType) {
    return {
        type: SELECT_DATA_FOR_CHART,
        dataType
    };
}

export function addUserWeight(payload, currentDate, actionToDispatch, reloadPage) {
    return {
        type: ADD_USER_WEIGHT,
        payload: payload,
        currentDate: currentDate,
        actionToDispatch: actionToDispatch,
        reloadPage
    };
}

export function fetchFirstWeight() {
    return {
        type: FETCH_FIRST_WEIGHT
    };
}

// ======= Selectors =======
export const getSelectedDataTypes = (state) => {
    return state.weightPage.weightPageState.selectedDataTypes;
};

export const getWeightOverlayEnabled = (state) => {
    return state.weightPage.weightPageState.overlayEnabled;
};

export const getCurrentPageDate = (state) => {
    return state.weightPage.weightPageState.currentPageDate;
};

export const isAddUserInProgress = (state) => {
    return state.weightPage.weightPageState.addUserWeightFetching;
};

export const getFirstWeight = (state) => {
    return state.weightPage.firstWeight;
};
